import { Box, MenuItem, Stack, Typography } from "@mui/material";
import { useContext } from "react";
import Label from "../../../components/label";
import CustomDropDown from "../../../components/select";
import TextInput from "../../../components/textInput";
import { AppContext } from "../../../lib/Context";
import { getTariffListPrice } from "../../../utils/helper";

// import LegacyTarrifService from "../../../json/AdditionalServiceLegacy.json";
// import DigitalTarrifService from "../../../json/AdditionalServiceNgn.json";
// import DigitalNgnTarrifOption from "../../../json/DigitalTarrif.json";
// import LegacyTarifOptions from "../../../json/LegacyTarrif.json";

import { useLocation } from "react-router-dom";

const ConnectionLines = ({
  mainIndex,
  option,
  lineIndex,
  vall,
  handleChangeLegacyValue,
  handleEditLegacySalePrice,
  handleChangeLegacyService,
  handleChangeNgnValue,
  handleChangeNgnService,
  legacyTarrifService,
  legacyTarifOptions,
  digitalNgnTarrifOption,
  digitalTarrifService,
}) => {
  const location = useLocation();
  const isDetailPage = location.pathname === "/prospect-details";
  const { contractLength } = useContext(AppContext);

  const converNantoEmptyString = (value) => {
    return isNaN(value) ? "" : value;
  };

  const tariffLabel = (list) =>
    `${list.value} (£${getTariffListPrice(list, contractLength)})`;

  return (
    <Box key={lineIndex} minWidth={300} maxWidth={330}>
      <Typography
        variant="h6"
        fontWeight={500}
        color={"text.davyGrey"}
        sx={{
          textDecoration: "underline",
        }}
      >
        Line {lineIndex + 1}
      </Typography>

      {/* Legacy tarif */}
      {option.legacyTariff.isSelected && (
        <>
          <Typography
            mt={0.5}
            variant="h6"
            fontWeight={500}
            color={"text.davyGrey"}
          >
            Legacy
          </Typography>
          <Stack
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Label title={"List of Legacy"} />
            {lineIndex === 0 && (
              <Label
                title={"(Applies to all lines)"}
                style={{ color: "primary.main" }}
              />
            )}
          </Stack>

          {lineIndex == 0 ? (
            <Stack gap={1}>
              <CustomDropDown
                variant={"filled"}
                value={vall?.legacy?.value || ""}
                readonly={isDetailPage}
              >
                {legacyTarifOptions.map((list, _ind) => {
                  return (
                    <MenuItem
                      key={_ind}
                      value={list.value}
                      onClick={() =>
                        handleChangeLegacyValue(
                          list,
                          mainIndex,
                          lineIndex,
                          "legacy"
                        )
                      }
                    >
                      {tariffLabel(list)}
                    </MenuItem>
                  );
                })}
              </CustomDropDown>

              {/* editable sale price box */}

              {vall?.legacy?.value && (
                <TextInput
                  variant={"filled"}
                  type={"number"}
                  error={vall?.legacy?.error}
                  helperText={vall?.legacy?.errorMessage}
                  value={vall?.legacy?.salePrice}
                  onChange={(e) =>
                    handleEditLegacySalePrice(
                      mainIndex,
                      lineIndex,
                      e.target.value,
                      vall,
                      "legacy",
                      true
                    )
                  }
                  readonly={isDetailPage}
                />
              )}
            </Stack>
          ) : (
            <Stack gap={1}>
              <TextInput
                variant={"filled"}
                value={vall?.legacy?.value || ""}
                readonly
              />
              {vall?.legacy?.value && (
                <TextInput
                  variant={"filled"}
                  value={converNantoEmptyString(vall?.legacy?.salePrice)}
                  error={vall?.legacy?.error}
                  helperText={vall?.legacy?.errorMessage}
                  readonly
                />
              )}
            </Stack>
          )}
        </>
      )}

      {/* Legacy services */}
      {option.legacyTariff.isSelected &&
        option.additionalService.isSelected && (
          <>
            <Stack spacing={1} mt={1}>
              <Stack
                direction={"row"}
                alignItems={"center"}
                justifyContent={"space-between"}
              >
                <Label title={"Service (1)"} />
                {lineIndex == 0 && (
                  <Label
                    title={"(Applies to all lines)"}
                    style={{ color: "primary.main" }}
                  />
                )}
              </Stack>
              {lineIndex === 0 ? (
                <Stack gap={1}>
                  <CustomDropDown
                    variant={"filled"}
                    value={vall?.legacyService1?.value || ""}
                    readonly={isDetailPage}
                  >
                    {legacyTarrifService.map((list, _ind) => {
                      return (
                        <MenuItem
                          key={_ind}
                          value={list.value}
                          onClick={() =>
                            handleChangeLegacyService(
                              list,
                              mainIndex,
                              lineIndex,
                              "legacyService1"
                            )
                          }
                        >
                          {tariffLabel(list)}
                        </MenuItem>
                      );
                    })}
                  </CustomDropDown>
                  {/* editable sale price box */}

                  {vall?.legacyService1?.value && (
                    <TextInput
                      variant={"filled"}
                      type={"number"}
                      error={vall?.legacyService1?.error}
                      helperText={vall?.legacyService1?.errorMessage}
                      value={vall?.legacyService1?.salePrice}
                      onChange={(e) =>
                        handleEditLegacySalePrice(
                          mainIndex,
                          lineIndex,
                          e.target.value,
                          vall,
                          "legacyService1",
                          true
                        )
                      }
                      readonly={isDetailPage}
                    />
                  )}
                </Stack>
              ) : (
                <Stack gap={1}>
                  <TextInput
                    variant={"filled"}
                    value={vall?.legacyService1?.value || ""}
                    readonly
                  />
                  {vall?.legacyService1?.value && (
                    <TextInput
                      variant={"filled"}
                      value={converNantoEmptyString(
                        vall?.legacyService1?.salePrice
                      )}
                      error={vall?.legacyService1?.error}
                      helperText={vall?.legacyService1?.errorMessage}
                      readonly
                    />
                  )}
                </Stack>
              )}
              <Stack
                direction={"row"}
                alignItems={"center"}
                justifyContent={"space-between"}
              >
                <Label title={"Service (2)"} />
                {lineIndex === 0 && (
                  <Label
                    title={"(Applies to all lines)"}
                    style={{ color: "primary.main" }}
                  />
                )}
              </Stack>
              {lineIndex === 0 ? (
                <Stack gap={1}>
                  <CustomDropDown
                    variant={"filled"}
                    value={vall?.legacyService2?.value || ""}
                    readonly={isDetailPage}
                  >
                    {legacyTarrifService.map((list, _ind) => {
                      return (
                        <MenuItem
                          key={_ind}
                          value={list.value}
                          onClick={() =>
                            handleChangeLegacyService(
                              list,
                              mainIndex,
                              lineIndex,
                              "legacyService2"
                            )
                          }
                        >
                          {tariffLabel(list)}
                        </MenuItem>
                      );
                    })}
                  </CustomDropDown>
                  {/* editable sale price box */}

                  {vall?.legacyService2?.value && (
                    <TextInput
                      variant={"filled"}
                      type={"number"}
                      error={vall?.legacyService2?.error}
                      helperText={vall?.legacyService2?.errorMessage}
                      value={vall?.legacyService2?.salePrice}
                      onChange={(e) =>
                        handleEditLegacySalePrice(
                          mainIndex,
                          lineIndex,
                          e.target.value,
                          vall,
                          "legacyService2",
                          true
                        )
                      }
                      readonly={isDetailPage}
                    />
                  )}
                </Stack>
              ) : (
                <Stack gap={1}>
                  <TextInput
                    variant={"filled"}
                    value={vall?.legacyService2?.value || ""}
                    readonly
                  />
                  {vall?.legacyService2?.value && (
                    <TextInput
                      variant={"filled"}
                      value={converNantoEmptyString(
                        vall?.legacyService2?.salePrice
                      )}
                      error={vall?.legacyService2?.error}
                      helperText={vall?.legacyService2?.errorMessage}
                      readonly
                    />
                  )}
                </Stack>
              )}
              <Stack
                direction={"row"}
                alignItems={"center"}
                justifyContent={"space-between"}
              >
                <Label title={"Service (3)"} />

                {lineIndex === 0 && (
                  <Label
                    title={"(Applies to all lines)"}
                    style={{ color: "primary.main" }}
                  />
                )}
              </Stack>
              {lineIndex === 0 ? (
                <Stack gap={1}>
                  <CustomDropDown
                    variant={"filled"}
                    value={vall?.legacyService3?.value || ""}
                    readonly={isDetailPage}
                  >
                    {legacyTarrifService.map((list, _ind) => {
                      return (
                        <MenuItem
                          key={_ind}
                          value={list.value}
                          onClick={() =>
                            handleChangeLegacyService(
                              list,
                              mainIndex,
                              lineIndex,
                              "legacyService3"
                            )
                          }
                        >
                          {tariffLabel(list)}
                        </MenuItem>
                      );
                    })}
                  </CustomDropDown>
                  {/* editable sale price box */}

                  {vall?.legacyService3?.value && (
                    <TextInput
                      variant={"filled"}
                      type={"number"}
                      error={vall?.legacyService3?.error}
                      helperText={vall?.legacyService3?.errorMessage}
                      value={vall?.legacyService3?.salePrice}
                      onChange={(e) =>
                        handleEditLegacySalePrice(
                          mainIndex,
                          lineIndex,
                          e.target.value,
                          vall,
                          "legacyService3",
                          true
                        )
                      }
                      readonly={isDetailPage}
                    />
                  )}
                </Stack>
              ) : (
                <Stack gap={1}>
                  <TextInput
                    variant={"filled"}
                    value={vall?.legacyService3?.value || ""}
                    readonly
                  />
                  {vall?.legacyService3?.value && (
                    <TextInput
                      variant={"filled"}
                      value={converNantoEmptyString(
                        vall?.legacyService3?.salePrice
                      )}
                      error={vall?.legacyService3?.error}
                      helperText={vall?.legacyService3?.errorMessage}
                      readonly
                    />
                  )}
                </Stack>
              )}
              <Stack
                direction={"row"}
                alignItems={"center"}
                justifyContent={"space-between"}
              >
                <Label title={"Service (4)"} />
                {lineIndex === 0 && (
                  <Label
                    title={"(Applies to all lines)"}
                    style={{ color: "primary.main" }}
                  />
                )}
              </Stack>
              {lineIndex === 0 ? (
                <Stack gap={1}>
                  <CustomDropDown
                    variant={"filled"}
                    value={vall?.legacyService4?.value || ""}
                    readonly={isDetailPage}
                  >
                    {legacyTarrifService.map((list, _ind) => {
                      return (
                        <MenuItem
                          key={_ind}
                          value={list.value}
                          onClick={() =>
                            handleChangeLegacyService(
                              list,
                              mainIndex,
                              lineIndex,
                              "legacyService4"
                            )
                          }
                        >
                          {tariffLabel(list)}
                        </MenuItem>
                      );
                    })}
                  </CustomDropDown>
                  {/* editable sale price box */}

                  {vall?.legacyService4?.value && (
                    <TextInput
                      variant={"filled"}
                      type={"number"}
                      error={vall?.legacyService4?.error}
                      helperText={vall?.legacyService4?.errorMessage}
                      value={vall?.legacyService4?.salePrice}
                      onChange={(e) =>
                        handleEditLegacySalePrice(
                          mainIndex,
                          lineIndex,
                          e.target.value,
                          vall,
                          "legacyService4",
                          true
                        )
                      }
                      readonly={isDetailPage}
                    />
                  )}
                </Stack>
              ) : (
                <Stack gap={1}>
                  <TextInput
                    variant={"filled"}
                    value={vall?.legacyService4?.value || ""}
                    readonly
                  />
                  {vall?.legacyService4?.value && (
                    <TextInput
                      variant={"filled"}
                      value={converNantoEmptyString(
                        vall?.legacyService4?.salePrice
                      )}
                      error={vall?.legacyService4?.error}
                      helperText={vall?.legacyService4?.errorMessage}
                      readonly
                    />
                  )}
                </Stack>
              )}
            </Stack>
          </>
        )}
      {/* Digital Ngn Tarrif */}
      {option.digitalTariff.isSelected && (
        <>
          <Typography
            mt={0.5}
            variant="h6"
            fontWeight={500}
            color={"text.davyGrey"}
          >
            Digital/NGN
          </Typography>

          <Label title={"List of digital/ngn"} />

          <Stack gap={1}>
            <CustomDropDown
              variant={"filled"}
              value={vall?.ngnValue?.value || ""}
              readonly={isDetailPage}
            >
              {digitalNgnTarrifOption.map((list, _ind) => {
                return (
                  <MenuItem
                    key={_ind}
                    value={list.value}
                    onClick={() =>
                      handleChangeNgnValue(
                        list,
                        mainIndex,
                        lineIndex,
                        "ngnValue"
                      )
                    }
                  >
                    {tariffLabel(list)}
                  </MenuItem>
                );
              })}
            </CustomDropDown>
            {/* editable sale price box */}

            {vall?.ngnValue?.value && (
              <TextInput
                variant={"filled"}
                type={"number"}
                error={vall?.ngnValue?.error}
                helperText={vall?.ngnValue?.errorMessage}
                value={vall?.ngnValue?.salePrice}
                onChange={(e) =>
                  handleEditLegacySalePrice(
                    mainIndex,
                    lineIndex,
                    e.target.value,
                    vall,
                    "ngnValue",
                    false
                  )
                }
                readonly={isDetailPage}
              />
            )}
          </Stack>
        </>
      )}

      {/* Additional Service */}
      {option.digitalTariff.isSelected &&
        option.additionalService.isSelected && (
          <>
            <Stack spacing={1} mt={1}>
              <Label title={"Service (1)"} />
              <Stack gap={1}>
                <CustomDropDown
                  variant={"filled"}
                  value={vall?.ngnService1?.value || ""}
                  readonly={isDetailPage}
                >
                  {digitalTarrifService.map((list, _ind) => {
                    return (
                      <MenuItem
                        key={_ind}
                        value={list.value}
                        onClick={() =>
                          handleChangeNgnService(
                            list,
                            mainIndex,
                            lineIndex,
                            "ngnService1"
                          )
                        }
                      >
                        {tariffLabel(list)}
                      </MenuItem>
                    );
                  })}
                </CustomDropDown>
                {/* editable sale price box */}

                {vall?.ngnService1?.value && (
                  <TextInput
                    variant={"filled"}
                    type={"number"}
                    error={vall?.ngnService1?.error}
                    helperText={vall?.ngnService1?.errorMessage}
                    value={vall?.ngnService1?.salePrice}
                    onChange={(e) =>
                      handleEditLegacySalePrice(
                        mainIndex,
                        lineIndex,
                        e.target.value,
                        vall,
                        "ngnService1",
                        false
                      )
                    }
                    readonly={isDetailPage}
                  />
                )}
              </Stack>
              <Label title={"Service (2)"} />
              <Stack gap={1}>
                <CustomDropDown
                  variant={"filled"}
                  value={vall?.ngnService2?.value || ""}
                  readonly={isDetailPage}
                >
                  {digitalTarrifService.map((list, _ind) => {
                    return (
                      <MenuItem
                        key={_ind}
                        value={list?.value}
                        onClick={() =>
                          handleChangeNgnService(
                            list,
                            mainIndex,
                            lineIndex,
                            "ngnService2"
                          )
                        }
                      >
                        {tariffLabel(list)}
                      </MenuItem>
                    );
                  })}
                </CustomDropDown>
                {/* editable sale price box */}

                {vall?.ngnService2?.value && (
                  <TextInput
                    variant={"filled"}
                    type={"number"}
                    error={vall?.ngnService2?.error}
                    helperText={vall?.ngnService2?.errorMessage}
                    value={vall?.ngnService2?.salePrice}
                    onChange={(e) =>
                      handleEditLegacySalePrice(
                        mainIndex,
                        lineIndex,
                        e.target.value,
                        vall,
                        "ngnService2",
                        false
                      )
                    }
                    readonly={isDetailPage}
                  />
                )}
              </Stack>
              <Label title={"Service (3)"} />
              <Stack gap={1}>
                <CustomDropDown
                  variant={"filled"}
                  value={vall?.ngnService3?.value || ""}
                  readonly={isDetailPage}
                >
                  {digitalTarrifService.map((list, _ind) => {
                    return (
                      <MenuItem
                        key={_ind}
                        value={list.value}
                        onClick={() =>
                          handleChangeNgnService(
                            list,
                            mainIndex,
                            lineIndex,
                            "ngnService3"
                          )
                        }
                      >
                        {tariffLabel(list)}
                      </MenuItem>
                    );
                  })}
                </CustomDropDown>
                {/* editable sale price box */}

                {vall?.ngnService3?.value && (
                  <TextInput
                    variant={"filled"}
                    type={"number"}
                    error={vall?.ngnService3?.error}
                    helperText={vall?.ngnService3?.errorMessage}
                    value={vall?.ngnService3?.salePrice}
                    onChange={(e) =>
                      handleEditLegacySalePrice(
                        mainIndex,
                        lineIndex,
                        e.target.value,
                        vall,
                        "ngnService3",
                        false
                      )
                    }
                    readonly={isDetailPage}
                  />
                )}
              </Stack>
              <Label title={"Service (4)"} />
              <Stack gap={1}>
                <CustomDropDown
                  variant={"filled"}
                  value={vall?.ngnService4?.value || ""}
                  readonly={isDetailPage}
                >
                  {digitalTarrifService.map((list, _ind) => {
                    return (
                      <MenuItem
                        key={_ind}
                        value={list.value}
                        onClick={() =>
                          handleChangeNgnService(
                            list,
                            mainIndex,
                            lineIndex,
                            "ngnService4"
                          )
                        }
                      >
                        {tariffLabel(list)}
                      </MenuItem>
                    );
                  })}
                </CustomDropDown>
                {/* editable sale price box */}

                {vall?.ngnService4?.value && (
                  <TextInput
                    variant={"filled"}
                    type={"number"}
                    error={vall?.ngnService4?.error}
                    helperText={vall?.ngnService4?.errorMessage}
                    value={vall?.ngnService4?.salePrice}
                    onChange={(e) =>
                      handleEditLegacySalePrice(
                        mainIndex,
                        lineIndex,
                        e.target.value,
                        vall,
                        "ngnService4",
                        false
                      )
                    }
                    readonly={isDetailPage}
                  />
                )}
              </Stack>
            </Stack>
          </>
        )}
    </Box>
  );
};

export default ConnectionLines;
